import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

(() => {
  const section = document.querySelector("#scroll-storytelling");
  if (!section) return;

  const textEl = section.querySelector(".js-text");
  if (!textEl) return;

  const messages = JSON.parse(section.dataset.messages || "[]");
  if (!messages.length) return;

  const total = messages.length;
  const scaleMax = 0.12;

  gsap.set(textEl, {
    transformOrigin: "center center"
  });

  const init = () => {

    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "bottom bottom",
      scrub: true,
      invalidateOnRefresh: true,

      onUpdate: (self) => {

        // podział sekcji na ilość tekstów
        const raw = self.progress * total;

        const index = Math.min(
          total - 1,
          Math.floor(raw)
        );

        if (textEl._current !== index) {
          textEl.textContent = messages[index];
          textEl._current = index;
        }

        let localProgress = raw % 1;

        if (index === total - 1) {
          localProgress = 1;
        }

        const scale = 1 + localProgress * scaleMax;

        gsap.set(textEl, {
          scale
        });
      }
    });

    ScrollTrigger.refresh();

  };


  // iOS Safari potrzebuje chwili na przeliczenie sticky/vh
  window.addEventListener("load", () => {
    setTimeout(() => {
      init();
    }, 300);
  });

})();